module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "app"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.isAuthed) + "\n    "), _c('navbar'), _vm._v(" "), (_vm.authed) ? _c('download-manager') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "layout",
    class: [_vm.routeName, {
      'full-width': _vm.expanded === true || _vm.expanded === 'true'
    }]
  }, [_c('div', {
    staticClass: "component widgets",
    class: {
      'hidden': _vm.isHidden
    }
  }, [(_vm.authed) ? _c('sidebar') : _vm._e(), _vm._v(" "), (_vm.authed) ? _c('widgets') : _vm._e()], 1), _vm._v(" "), _c('main', {
    staticClass: "component main clearfix"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "overlay"
  }, [_c('loader')], 1) : _vm._e(), _vm._v(" "), _c('router-view', {
    key: _vm.routerViewKey
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-86c2439c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 2069
// module chunks = 2